import ReactPaginate from 'react-paginate'
import style from './style.module.scss'
import { memo } from 'react'

export type Selected = {
  selected: number
}

interface Props {
  pageCount?: number
  handlePageClick: (paginationData: Selected) => void
}

 const Pagination = ({ pageCount = 0, handlePageClick }: Props) =>{ 
  return (
  <>
    {pageCount > 1 && (
      <ReactPaginate
        containerClassName={style.pagination}
        activeClassName={style.active}
        pageClassName={style.pageItem}
        breakClassName={style.break}
        breakLabel="..."
        previousLabel={
          <button type="button" className={style.arrowButton}>
          ←
          </button>
        }
        onPageChange={handlePageClick}
        pageRangeDisplayed={4}
        pageCount={pageCount}
        nextLabel={
          <button type="button" className={style.arrowButton}>
          →
          </button>
        }
        renderOnZeroPageCount={null}
      />
    )}
  </>
)}

export default memo(Pagination);